import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Card, CardTitle, CardBody, Button } from 'reactstrap';

class ExpandableCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        }
    }

    static propTypes = {
        title: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
    }

    render() {
        const { expanded } = this.state;
        const { title, children } = this.props;
        return (
            <Col className={'col-12 col-transition' + (!expanded ? ' col-lg-6' : '')}>
                <Card body className="border-0 p-0 mb-3">
                    <CardTitle className="text-center py-2 col-color">
                        {title}
                        <Button
                            className="btn-expand d-none d-lg-block"
                            onClick={() => this.setState(prevState => ({ expanded: !prevState.expanded }))}
                        >
                            <i className={'fa' + (expanded ? ' fa-compress' : ' fa-expand')}></i>
                        </Button>
                    </CardTitle>
                    <CardBody>{children}</CardBody>
                </Card>
            </Col>
        );
    }
}

export default ExpandableCard;


// WEBPACK FOOTER //
// ./src/views/Reportes/ExpandableCard.js